import { KYCBASEURL } from '../../constants/global';
import { type IKYCFaceEnrolResponse, type IKYCFaceMatchResponse, type IKYCIdCheckResponse } from '../../interface/IAgents';
import { kycType } from '../types';
import * as utils from './utils';

const buildFileFormData = (file: File): FormData => {
	const fd = new FormData();
	fd.append('file', file);
	return fd;
};

// KYC requests need NO custom headers — adding any header (especially the
// non-standard Access-Control-Allow-Origin from headerMultiPart) makes the
// request "non-simple" and forces a CORS preflight that the KYC service
// can't satisfy. Letting fetch set Content-Type with the multipart boundary
// keeps it a simple request.
const kycHeaders = (): Record<string, string> => ({});

export const kycEnrolFaceAction = (
	file: File,
	onSuccess?: (res: IKYCFaceEnrolResponse) => void,
	onFailure?: (err: any) => void
) =>
	utils.httpUploadMediaMethod({
		apiData: {
			url: '',
			customurl: `${KYCBASEURL}/kyc/face/upload`,
			header: kycHeaders(),
			data: buildFileFormData(file),
		},
		actionType: kycType.enrolFace,
		onSuccess,
		onFailure,
	});

// Video enrolment: stronger liveness signal, multi-frame sample.
export const kycEnrolFaceVideoAction = (
	file: File,
	onSuccess?: (res: IKYCFaceEnrolResponse) => void,
	onFailure?: (err: any) => void
) =>
	utils.httpUploadMediaMethod({
		apiData: {
			url: '',
			customurl: `${KYCBASEURL}/kyc/face/upload-video`,
			header: kycHeaders(),
			data: buildFileFormData(file),
		},
		actionType: kycType.enrolFace,
		onSuccess,
		onFailure,
	});

export const kycCheckIdAction = (file: File, onSuccess?: (res: IKYCIdCheckResponse) => void, onFailure?: (err: any) => void) =>
	utils.httpUploadMediaMethod({
		apiData: {
			url: '',
			customurl: `${KYCBASEURL}/kyc/id/check`,
			header: kycHeaders(),
			data: buildFileFormData(file),
		},
		actionType: kycType.checkId,
		onSuccess,
		onFailure,
	});

export const kycMatchFaceAction = (
	faceId: string,
	file: File,
	onSuccess?: (res: IKYCFaceMatchResponse) => void,
	onFailure?: (err: any) => void
) =>
	utils.httpUploadMediaMethod({
		apiData: {
			url: '',
			customurl: `${KYCBASEURL}/kyc/face/match/${encodeURIComponent(faceId)}`,
			header: kycHeaders(),
			data: buildFileFormData(file),
		},
		actionType: kycType.matchFace,
		onSuccess,
		onFailure,
	});
